import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from '@mui/material';
import {
  HelpCenter as HelpCenterIcon,
} from '@mui/icons-material';

export default function HelpDialog(props) {
  const {open, onClose} = props;

  const handleCloseHelper = () => {
    onClose(false);
  }

  return(
    <Dialog open={open} onClose={handleCloseHelper}>
      <DialogTitle>Easy WhatsApp</DialogTitle>
      <DialogContent>
        <Typography gutterBottom sx={{mb:1}}>
          Text Away is a Progressive Web App (PWA) that allows you to start a WhatsApp conversation without the need to save recipient phone number into your contacts.
        </Typography>
        <Typography gutterBottom sx={{mb:1}}>
          Install this app on your home screen for quick access. On iPhone and iPad, use Safari, tap Share, then Add to Home Screen. On Android, use your browser&apos;s install or add to home screen option.
        </Typography>

        <Box sx={{m: 2.5, display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <Button variant='contained' href='https://web.dev/learn/pwa/progressive-web-apps/#mobile-devices'>
            <HelpCenterIcon sx={{mr: 1, fontSize:'25px'}}/>
            How to install
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
